import { useQuery } from "@tanstack/react-query";
import { useFarmerId } from "@/layout/hooks/useFarmerId";
import DashboardLayout from "@/layout/components/DashboardLayout";
import ReactQueryAsyncValueWrapper from "@/shared/components/wrappers/ReactQueryAsyncValueWrapper";
import { QUERY_KEYS } from "@/features/farmer/domain/farmer-enum";
import { Profile } from "@/features/farmer/domain/farmer-interface";
import { farmerProfileService } from "@/features/farmer/application/farmer-service";

const LayoutWrapper = () => {
  const [farmerId] = useFarmerId();
  const profileQuery = useQuery({
    queryKey: [QUERY_KEYS.getProfile, farmerId],
    queryFn: () => farmerProfileService(farmerId!),
    cacheTime: 0,
    enabled: !!farmerId,
  });

  return (
    <div className="flex justify-center h-[100vh] items-center">
      <ReactQueryAsyncValueWrapper<Profile | undefined> state={profileQuery}>
        {(profile) => <DashboardLayout profile={profile!} />}
      </ReactQueryAsyncValueWrapper>
    </div>
  );
};

export default LayoutWrapper;
